<!--
 * @Version      : V1.0
 * @Date         : 2025-06-05 16:29:37
 * @fileName     : 首页
 * @Description  :
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <!-- <el-card class="box-card">
      <div class="query-con">

      </div>
    </el-card> -->
    <div class="operate py-10 px-10 border-box" style="background-color: white;margin-top: 10px;">
      <h4 class="operate-title">待审批</h4>
      <div class="pending-approval">
        <!-- <div class="box-card-sum flex items-center justify-between a" v-for="(item, index) in pendingApprovalList"
          :key="index" @click="jumpPage(item.page)">
          <div class="sum-main ">
            <div class="sum-title">
              <span>{{ item.label }}</span>
            </div>
            <div class="sum-bg">
              <el-statistic group-separator="," :value="item.value"
                :value-style="{ fontSize: '25px', color: '#FFF' }"></el-statistic>
            </div>
          </div>
          <div class="sum-icon">
            <i :class="[item.icon]"></i>
          </div>
        </div> -->
        <div class="box-card-sum a" v-for="(item, index) in pendingApprovalList" :key="index"
          @click="jumpPage(item.page)">
          <div class="sum-main">
            <div class="sum-bg">
              <el-statistic v-if="item.value == 0" group-separator="," :value="item.value"
                :value-style="{ fontSize: '30px', color: '#000', fontWeight: 'bold' }"></el-statistic>
              <el-statistic v-else group-separator="," :value="item.value"
                :value-style="{ fontSize: '30px', color: '#f50505', fontWeight: 'bold' }"></el-statistic>
            </div>
            <div class="sum-title">
              <span style="color: #000;" class="font-weight-bold">{{ item.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="operate py-10 px-10 border-box" style="background-color: white;margin-top: 10px;margin-bottom: 10px;">
      <h4 class="operate-title">统计数据</h4>
      <div class="box-card-top">
        <div class="box-card-sum flex items-center justify-between a" v-for="(item, index) in sumDataT" :key="index"
          @click="jumpPage(item.page)">
          <div class="sum-main ">
            <div class="sum-title">
              <span class="font-weight-bold font-small">{{ item.label }}</span>
            </div>
            <div class="sum-bg">
              <el-statistic group-separator="," :precision="item.key=='contract_amount'?2:0" :value="item.value"
                :value-style="{ fontSize: '25px', color: '#fff' }"></el-statistic>
            </div>
          </div>
          <div class="sum-icon">
            <i style="color: #064aa0" :class="[item.icon]"></i>
          </div>
        </div>
      </div>
      <div class="box-card-bottom">
        <div class="box-card-sum flex items-center justify-between a" v-for="(item, index) in sumDataB" :key="index"
          @click="jumpPage(item.page)">
          <div class="sum-main ">
            <div class="sum-title">
              <span class="font-weight-bold font-small">{{ item.label }}</span>
            </div>
            <div class="sum-bg-special flex items-center" v-if="item.beExpectedToKey">
              <div class="special-invoiced">
                <el-statistic group-separator="," :precision="2" :value="item.value"
                  :value-style="{ fontSize: '25px', color: '#fff' }"></el-statistic>
              </div>

              <div class="special-received flex items-center">
                <span class="received-title">已回款:</span>
                <el-statistic group-separator="," :precision="2" :value="item.beExpectedToValue"
                  :value-style="{ fontSize: '25px', color: '#fff' }"></el-statistic>
              </div>

            </div>
            <div class="sum-bg" v-else>
              <el-statistic group-separator="," :precision="2" :value="item.value"
                :value-style="{ fontSize: '25px', color: '#fff' }"></el-statistic>
            </div>
          </div>
          <div class="sum-icon">
            <i style="color: #064aa0" :class="[item.icon]"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #ifArchiveSlot="{ row }">
          <div>
            <el-tag :type="row.ifArchive == 0 ? 'danger' : 'success'" effect="dark">{{ row.ifArchive == 0 ? "否" : "是"
            }}</el-tag>
          </div>
        </template>
        <!--<template #operate="{ row }">
          <div>
            <el-button type="text" @click="stopService(row)" v-if="row.ifStopService == 0">停止服务</el-button>
          </div>
        </template> -->
      </tableComponent>
    </div>

  </div>
</template>

<script>
import tableComponent from '@/components/tableComponent/index.vue'
import { auditProcessStatus, formatterState } from '@/utils/index'
import { queryPageForIndexApi, getWaitAuditApi, getWaitArchiveApi, getCheckedAndCreditedIntoAccountApi, getNearExpirationApi, getYearDataApi, getMoonDataApi } from '@/api/home/index'
import { queryPageForLedgerListApi } from '@/api/receivableContract‌/index'
import { querySupplierInfoListApi, queryChargeListtApi } from '@/api/basicInfo/index'
export default {
  components: {
    tableComponent,
  },
  data() {
    return {
      loading: false,
      contractCount: 0,
      totalAmount: 0,
      detailsT: '',
      pendingApprovalList: [
        {
          label: '项目立项',
          key: 'project_wait_audit_count',
          page: '/project/auditProject/list',
          icon: 'el-icon-menu',
          value: 0
        },
        {
          label: '收款签约',
          key: 'contractReceivePayment_wait_audit_count',
          page: '/receivableContract/auditContract',
          icon: 'el-icon-document-add',
          value: 0
        },
        {
          label: '付款签约',
          key: 'contractMakePayment_wait_audit_count',
          page: '/paymentContract/auditPayContract',
          icon: 'el-icon-document-remove',
          value: 0
        },
        {
          label: '用印申请',
          key: 'sealApplication_wait_audit_count',
          page: '/sealApplication/auditSeal',
          icon: 'el-icon-s-check',
          value: 0
        },
        {
          label: '开票申请',
          key: 'finReceivedInvoice_wait_audit_count',
          page: '/finReceivedInvoiceItem/auditInvoice',
          icon: 'el-icon-s-ticket',
          value: 0
        },
        {
          label: '付款申请',
          key: 'finMakePayment_wait_audit_count',
          page: '/paymentApplication/auditPayApplication',
          icon: 'el-icon-document-remove',
          value: 0
        },
        {
          label: '费用报销申请',
          key: 'finReimbursement_wait_audit_count',
          page: '/expenseReimbursement/auditPayExpense',
          icon: 'el-icon-tickets',
          value: 0
        },
        {
          label: '采购申请',
          key: 'finPurchase_wait_audit_count',
          page: '/purchaseRequisition/auditPurchase',
          icon: 'el-icon-s-finance',
          value: 0
        },
        {
          label: '供应商付款申请',
          key: 'finMakePaymentSup_wait_audit_count',
          page: '/supplierPay/auditSupplierPay',
          icon: 'el-icon-s-finance',
          value: 0
        },
        {
          label: '电费付款待审核',
          key: 'finElectricityPayment_wait_audit_count',
          page: '/myElectricityFeePay/auditPayElectricityFee',
          icon: 'el-icon-s-finance',
          value: 0
        },
        {
          label: '电费收款待审核',
          key: 'finElectricityCollection_wait_audit_count',
          page: '/electricityFeeCollection/auditElectricityFee',
          icon: 'el-icon-s-finance',
          value: 0
        }
      ],
      sumDataT: [
        {
          label: '待归档数量',
          key: 'wait_archive_count',
          page:'/contractFiling',
          icon: 'el-icon-folder-opened',
          value: 0
        },
        {
          label: '开票 - 待查款到账数量',
          key: 'wait_CheckedAndCreditedIntoAccount_count',
          page: '/finReceivedInvoiceItem/checkPaymentReceived',
          icon: 'el-icon-s-platform',
          value: 0
        },
        {
          label: '电费收款 - 待查款到账数量',
          key: 'wait_ElectricityCollection_count',
          page: '/electricityFeeCollection/checkPayElectricityFee',
          icon: 'el-icon-s-platform',
          value: 0
        },
        {
          label: '电费收款-待上传发票',
          key: 'wait_electricityCollection_noUploadInvoice_count',
          page: '/electricityFeeCollection/uploadInvoiceEF',
          icon: 'el-icon-s-platform',
          value: 0
        },
        {
          label: '电费付款-待上传发票',
          key: 'wait_electricityPayment_noUploadInvoice_count',
          page: '/electricityFeePay/uploadInvoicePay',
          icon: 'el-icon-s-platform',
          value: 0
        },
        {
          label: '到期合同提醒',
          key: 'contractCount',
          page: '/contractExpirationReminder',
          icon: 'el-icon-message-solid',
          value: 0
        },
        {
          label: '年度总规模',
          key: 'contract_amount',
          icon: 'el-icon-data-analysis',
          page: '',
          value: 0
        },

      ],
      sumDataB: [
        {
          label: '年度总利润',
          key: 'total_profit',
          icon: 'el-icon-bank-card',
          page: '',
          value: 0
        },
        {
          label: '上月累计回款金额',
          key: 'last_moon_receivedAmount',
          icon: 'el-icon-bank-card',
          page: '/finReceivedInvoiceItem/myInvoice?month=-1',
          value: 0
        },
        {
          label: '本月预计回款金额',
          key: 'current_moon_invoicedAmount',
          beExpectedToKey: 'current_moon_receivedAmount',
          icon: 'el-icon-bank-card',
          page: '/finReceivedInvoiceItem/myInvoice?month=0',
          value: 0,
          beExpectedToValue: 0
        }
      ],
      formInline: {
        signingDateYear: "",
        contractFinishStatus: ""
      },
      queryForm: {
        id: "",
        customerId: "",
        ownerChargePersonId: "",
        ifArchive: ""
      },
      receivableContractOption: [],
      customerOption: [],
      ownerChargePersonOption: [],
      dataList: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "58px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "合同名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "contractName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "客户联系人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "customerChargePerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "客户联系电话", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerContactPhone", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "我方单位", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "ownerUnitName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "我方负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "ownerChargePersonName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "合同归档", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "60px",
          keyName: "ifArchive", // 数据的属性值
          align: "center",
          slotName: "ifArchiveSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "合同金额", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 11,
          title: "已开票", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "invoicedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 12,
          title: "未开票", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "noInvoicedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 13,
          title: "已收款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "receivedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 14,
          title: "未收款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "noReceivedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 15,
          title: "合同利润", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "profit", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 113,
          title: "电费收款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "electricityCollectionAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 114,
          title: "电费付款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "electricityPaymentAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 16,
          title: "合同状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractFinishStatusLabel", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 20,
          title: "签约时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "signingDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 17,
          title: "合同开始时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "startDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 18,
          title: "合同结束时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "endDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 19,
          title: "合同期限(天)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractDuration", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.queryData()
    this.getLedgerContractList()
    this.getCurtomer()
    this.getChargeList()

  },
  methods: {
    auditProcessStatus,
    formatterState,
    //查询
    queryData() {
      this.initData()
      this.querySum()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            signingDateYear: "",
            contractFinishStatus: "",//合同完成状态 0 未完成 1已完成
            ...this.formInline
          },
          id: "",//合同id
          customerId: "",//客户ID
          ownerChargePersonId: "", //我方负责人id(经办人)
          ifArchive: "",//是否归档 1 是 0 否
          ...this.queryForm
        },
        ...item
      }
      this.loading = true;
      queryPageForIndexApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.signingDateYear = "";
      this.formInline.contractFinishStatus = "";
      this.queryForm.id = "";
      this.queryForm.contractFinishStatus = "";
      this.queryForm.customerId = "";
      this.queryForm.ownerChargePersonId = "";
      this.$nextTick(() => {
        this.initData()
        this.querySum()
      })
    },
    //查询收款合同台账
    getLedgerContractList(v = '') {
      let params = {
        params: {
          contractName: "",
        }
      }
      this.selectLoading = true;
      queryPageForLedgerListApi(params).then(res => {
        this.selectLoading = false;
        if (res.code == 200) {
          this.receivableContractOption = res.data;
        }
      })
    },
    //获取客户档案
    getCurtomer() {
      let params = {
        customerName: ""
      }
      querySupplierInfoListApi(params).then(res => {
        if (res.code == 200) {
          this.customerOption = res.data;
        }
      })
    },
    //我方负责人下拉
    getChargeList() {
      let params = {}
      queryChargeListtApi(params).then(res => {
        if (res.code == 200) {
          this.ownerChargePersonOption = res.data;
        }
      })
    },
    //获取执行统计数据
    querySum() {
      // 待审核数量
      getWaitAuditApi({}).then(res => {
        if (res.code == 200) {
          for (let key in res.data) {
            for (let i = 0; i < this.pendingApprovalList.length; i++) {
              if (this.pendingApprovalList[i].key == key) {
                this.pendingApprovalList[i].value = Number(res.data[key])
              }
            }
          }

        }
      })
      // 待归档数量
      getWaitArchiveApi({}).then(res => {
        if (res.code == 200) {
          this.sumDataT[0].value = Number(res.data.wait_archive_count) || 0;
        }
      })
      // 待查款到账数量
      getCheckedAndCreditedIntoAccountApi({}).then(res => {
        if (res.code == 200) {
          this.sumDataT[1].value = Number(res.data.wait_CheckedAndCreditedIntoAccount_count) || 0;
          this.sumDataT[2].value = Number(res.data.wait_ElectricityCollection_count) || 0;
          this.sumDataT[3].value = Number(res.data.wait_electricityCollection_noUploadInvoice_count) || 0;
          this.sumDataT[4].value = Number(res.data.wait_electricityPayment_noUploadInvoice_count) || 0;
        }
      })
      // 合同到期提醒数量
      getNearExpirationApi({}).then(res => {
        if (res.code == 200) {
          this.sumDataT[5].value = Number(res.data.contractCount) || 0;
        }
      })
      // 获取年度数据
      getYearDataApi({}).then(res => {
        if (res.code == 200) {
          this.sumDataT[6].value = Number(res.data.contract_amount) || 0;
          this.sumDataB[0].value = Number(res.data.total_profit) || 0;
        }
      })
      // 获取月度数据
      getMoonDataApi({}).then(res => {
        if (res.code == 200) {
          this.sumDataB[1].value = Number(res.data.last_moon_receivedAmount) || 0;
          this.sumDataB[2].value = Number(res.data.current_moon_invoicedAmount) || 0;
          this.sumDataB[2].beExpectedToValue = Number(res.data.current_moon_receivedAmount) || 0;
        }
      })
    },
    jumpPage(url) {
      if (!url) {
        return false
      }
      //查款到账上个月
      if (url.includes('/finReceivedInvoiceItem/myInvoice')) {
        let urlArr = url.split('?');
        if (this.$store.state.user.ifZjl == 1) {
          this.$router.push('/finReceivedInvoiceItem/ledgerInvoice' + '?' + urlArr[1])
        } else {
          this.$router.push(url)
        }
      }else if(url.includes('/receivableContract/ledgerContract') || url.includes('/finReceivedInvoiceItem/checkPaymentReceived') || url.includes('/electricityFeePay/uploadInvoicePay') || url.includes('/electricityFeeCollection/uploadInvoiceEF')){
        if(this.$store.state.user.account=='wl' || this.$store.state.user.account=='ls' || this.$store.state.user.account=='admin'){
          this.$router.push(url)
        }
      } else {
        this.$router.push(url)
      }

    },
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }



  .operate {
    .operate-title {
      line-height: 40px;
    }

    .box-card-top {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      grid-gap: 20px 20px;
      grid-template-rows: 100px;

      .box-card-sum {
        height: 100%;
        border-radius: 5px;
        padding: 10px;
        box-sizing: border-box;
        // border: 1px solid #a9a8a8;
        background-color: #54bcbd;

        .sum-main {
          .sum-title {
            color: #FFF;
            font-size: 18px;
            font-weight: 500;
          }

          .sum-bg {
            padding-top: 20px;
            display: inline-block;
            box-sizing: border-box;
          }
        }

        .sum-icon {
          font-size: 38px;
          color: #409EFF;
        }

      }
    }

    .box-card-bottom {
      margin-top: 20px;
      @extend .box-card-top;
      grid-template-columns: repeat(3, 1fr);

      .box-card-sum {
        //background-color: #54bcbd;
        background-color: #408a8b;

        .sum-main {
          @extend .sum-main;
          width: 100%;

          .sum-bg-special {
            padding-top: 20px;
            box-sizing: border-box;
            width: 100%;

            .special-received {

              .received-title {
                margin-left: 30px;
                min-width: 50px;
                color: #fff;
                font-size: 15px;
                display: block;
              }
            }

          }
        }

        .sum-icon {
          font-size: 38px;
          color: #409EFF;
        }
      }

    }

    .pending-approval {

      display: grid;
      grid-template-columns: repeat(11, 1fr);
      grid-gap: 10px 10px;
      grid-template-rows: 100px;
      // background: gray;
      padding: 20px 0;

      .box-card-sum {
        height: 100%;
        border-radius: 5px;
        padding: 5px;
        box-sizing: border-box;
        // border: 1px solid #a9a8a8;
        text-align: center;
        //background-color: #eaebed;
        background-color: #c3e9f0;

        .sum-main {
          .sum-title {
            color: #222;
            font-size: 16px;
            padding-top: 5px;
            box-sizing: border-box;
          }

          .sum-bg {
            padding-top: 20px;
            display: inline-block;
            box-sizing: border-box;
          }

        }

        .sum-icon {
          font-size: 38px;
          color: #409EFF;
        }

      }
    }
  }
}
</style>
